var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function () {
          return [
            _c(
              "button",
              {
                on: {
                  click: _vm.showModal,
                  mouseover: function ($event) {
                    _vm.isHovered = true
                  },
                  mouseout: function ($event) {
                    _vm.isHovered = false
                  },
                },
              },
              [
                !_vm.isHovered
                  ? _c("MessageIcon", { staticClass: "w-4 h-4.5" })
                  : _vm._e(),
                _vm.isHovered
                  ? _c("MessageIconHover", { staticClass: "w-4 h-4.5" })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        { showModal: _vm.showModal }
      ),
      _c("CreateGroupConversationModal", {
        attrs: {
          companyId: _vm.companyId,
          currentUserId: _vm.currentUser.id,
          projectTitle: _vm.project.name,
          groupConversationUsers: _vm.projectUsers,
        },
        model: {
          value: _vm.modalShown,
          callback: function ($$v) {
            _vm.modalShown = $$v
          },
          expression: "modalShown",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }